export default __webpack_public_path__ + "static/media/png.83c9942e.svg";